var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"none"},[_c('img',{attrs:{"src":require("../assets/img/none.png"),"alt":"没有内容展示图片"}}),_c('span',[_vm._v("暂时没有任何内容")])])
}]

export { render, staticRenderFns }